import _createForOfIteratorHelper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/converters/upcasttable
 */

import { createEmptyTableCell } from '../commands/utils';

/**
 * View table element to model table element conversion helper.
 *
 * This conversion helper converts the table element as well as table rows.
 *
 * @returns {Function} Conversion helper.
 */
export default function upcastTable() {
  return function (dispatcher) {
    dispatcher.on('element:table', function (evt, data, conversionApi) {
      var viewTable = data.viewItem;

      // When element was already consumed then skip it.
      if (!conversionApi.consumable.test(viewTable, {
        name: true
      })) {
        return;
      }
      var _scanTable = scanTable(viewTable),
        rows = _scanTable.rows,
        headingRows = _scanTable.headingRows,
        headingColumns = _scanTable.headingColumns;

      // Only set attributes if values is greater then 0.
      var attributes = {};
      if (headingColumns) {
        attributes.headingColumns = headingColumns;
      }
      if (headingRows) {
        attributes.headingRows = headingRows;
      }
      var table = conversionApi.writer.createElement('table', attributes);

      // Insert element on allowed position.
      var splitResult = conversionApi.splitToAllowedParent(table, data.modelCursor);

      // When there is no split result it means that we can't insert element to model tree, so let's skip it.
      if (!splitResult) {
        return;
      }
      conversionApi.writer.insert(table, splitResult.position);
      conversionApi.consumable.consume(viewTable, {
        name: true
      });
      if (rows.length) {
        // Upcast table rows in proper order (heading rows first).
        rows.forEach(function (row) {
          return conversionApi.convertItem(row, conversionApi.writer.createPositionAt(table, 'end'));
        });
      } else {
        // Create one row and one table cell for empty table.
        var row = conversionApi.writer.createElement('tableRow');
        conversionApi.writer.insert(row, conversionApi.writer.createPositionAt(table, 'end'));
        createEmptyTableCell(conversionApi.writer, conversionApi.writer.createPositionAt(row, 'end'));
      }

      // Set conversion result range.
      data.modelRange = conversionApi.writer.createRange(
      // Range should start before inserted element
      conversionApi.writer.createPositionBefore(table),
      // Should end after but we need to take into consideration that children could split our
      // element, so we need to move range after parent of the last converted child.
      // before: <allowed>[]</allowed>
      // after: <allowed>[<converted><child></child></converted><child></child><converted>]</converted></allowed>
      conversionApi.writer.createPositionAfter(table));

      // Now we need to check where the modelCursor should be.
      // If we had to split parent to insert our element then we want to continue conversion inside split parent.
      //
      // before: <allowed><notAllowed>[]</notAllowed></allowed>
      // after:  <allowed><notAllowed></notAllowed><converted></converted><notAllowed>[]</notAllowed></allowed>
      if (splitResult.cursorParent) {
        data.modelCursor = conversionApi.writer.createPositionAt(splitResult.cursorParent, 0);

        // Otherwise just continue after inserted element.
      } else {
        data.modelCursor = data.modelRange.end;
      }
    });
  };
}
export function upcastTableCell(elementName) {
  return function (dispatcher) {
    dispatcher.on("element:".concat(elementName), function (evt, data, conversionApi) {
      var viewTableCell = data.viewItem;

      // When element was already consumed then skip it.
      if (!conversionApi.consumable.test(viewTableCell, {
        name: true
      })) {
        return;
      }
      var tableCell = conversionApi.writer.createElement('tableCell');

      // Insert element on allowed position.
      var splitResult = conversionApi.splitToAllowedParent(tableCell, data.modelCursor);

      // When there is no split result it means that we can't insert element to model tree, so let's skip it.
      if (!splitResult) {
        return;
      }
      conversionApi.writer.insert(tableCell, splitResult.position);
      conversionApi.consumable.consume(viewTableCell, {
        name: true
      });
      var modelCursor = conversionApi.writer.createPositionAt(tableCell, 0);
      conversionApi.convertChildren(viewTableCell, modelCursor);

      // Ensure a paragraph in the model for empty table cells.
      if (!tableCell.childCount) {
        conversionApi.writer.insertElement('paragraph', modelCursor);
      }

      // Set conversion result range.
      data.modelRange = conversionApi.writer.createRange(
      // Range should start before inserted element
      conversionApi.writer.createPositionBefore(tableCell),
      // Should end after but we need to take into consideration that children could split our
      // element, so we need to move range after parent of the last converted child.
      // before: <allowed>[]</allowed>
      // after: <allowed>[<converted><child></child></converted><child></child><converted>]</converted></allowed>
      conversionApi.writer.createPositionAfter(tableCell));

      // Continue after inserted element.
      data.modelCursor = data.modelRange.end;
    });
  };
}

// Scans table rows and extracts required metadata from the table:
//
// headingRows    - the number of rows that goes as table header.
// headingColumns - max number of row headings.
// rows           - sorted `<tr>`s as they should go into the model - ie. if `<thead>` is inserted after `<tbody>` in the view.
//
// @param {module:engine/view/element~Element} viewTable
// @returns {{headingRows, headingColumns, rows}}
function scanTable(viewTable) {
  var tableMeta = {
    headingRows: 0,
    headingColumns: 0
  };

  // The `<tbody>` and <thead> sections in the DOM do not have to be in order `<thead>` -> `<tbody>` and there might be more then one of
  // them.
  // As the model does not have those sections, rows from different sections must be sorted.
  // For example, below is a valid HTML table:
  //
  //		<table>
  //			<tbody><tr><td>2</td></tr></tbody>
  //			<thead><tr><td>1</td></tr></thead>
  //			<tbody><tr><td>3</td></tr></tbody>
  //		</table>
  //
  // But browsers will render rows in order as: 1 as heading and 2 and 3 as (body).
  var headRows = [];
  var bodyRows = [];

  // Currently the editor does not support more then one <thead> section.
  // Only the first <thead> from the view will be used as heading rows and others will be converted to body rows.
  var firstTheadElement;
  for (var _i = 0, _Array$from = Array.from(viewTable.getChildren()); _i < _Array$from.length; _i++) {
    var tableChild = _Array$from[_i];
    // Only <thead>, <tbody> & <tfoot> from allowed table children can have <tr>s.
    // The else is for future purposes (mainly <caption>).
    if (tableChild.name === 'tbody' || tableChild.name === 'thead' || tableChild.name === 'tfoot') {
      // Save the first <thead> in the table as table header - all other ones will be converted to table body rows.
      if (tableChild.name === 'thead' && !firstTheadElement) {
        firstTheadElement = tableChild;
      }

      // There might be some extra empty text nodes between the `tr`s.
      // Make sure further code operates on `tr`s only. (#145)
      var trs = Array.from(tableChild.getChildren()).filter(function (el) {
        return el.is('element', 'tr');
      });
      var _iterator = _createForOfIteratorHelper(trs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tr = _step.value;
          // This <tr> is a child of a first <thead> element.
          if (tr.parent.name === 'thead' && tr.parent === firstTheadElement) {
            tableMeta.headingRows++;
            headRows.push(tr);
          } else {
            bodyRows.push(tr);
            // For other rows check how many column headings this row has.

            var headingCols = scanRowForHeadingColumns(tr, tableMeta, firstTheadElement);
            if (headingCols > tableMeta.headingColumns) {
              tableMeta.headingColumns = headingCols;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  tableMeta.rows = [].concat(headRows, bodyRows);
  return tableMeta;
}

// Scans `<tr>` and its children for metadata:
// - For heading row:
//     - either adds this row to heading or body rows.
//     - updates number of heading rows.
// - For body rows:
//     - calculates the number of column headings.
//
// @param {module:engine/view/element~Element} tr
// @returns {Number}
function scanRowForHeadingColumns(tr) {
  var headingColumns = 0;
  var index = 0;

  // Filter out empty text nodes from tr children.
  var children = Array.from(tr.getChildren()).filter(function (child) {
    return child.name === 'th' || child.name === 'td';
  });

  // Count starting adjacent <th> elements of a <tr>.
  while (index < children.length && children[index].name === 'th') {
    var th = children[index];

    // Adjust columns calculation by the number of spanned columns.
    var colspan = parseInt(th.getAttribute('colspan') || 1);
    headingColumns = headingColumns + colspan;
    index++;
  }
  return headingColumns;
}